import { render, staticRenderFns } from "./CollectionSearch.vue?vue&type=template&id=1d291004&"
import script from "./CollectionSearch.vue?vue&type=script&lang=js&"
export * from "./CollectionSearch.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports